import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/plugins/vant.js';
// 注册公用渲染方法
import '@/utils/registerBaseStyle.js'
import '@/utils/globalRegister.js'
import globalMixin from '@utils/globalMixin'
import api from './api/index'
Vue.config.productionTip = false
Vue.prototype.$api = api

Vue.mixin(globalMixin)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
